module.exports = __webpack_public_path__ + "img/Kiwi.2cf97b7e.svg";